import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateTaxZone } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useUpdateTaxZone = () => {
    const queryClient = useQueryClient();

    const { mutate: updateTaxZoneMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateTaxZone(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Tax zone updated successfully");
            queryClient.invalidateQueries(["tax-zones"]);
            queryClient.invalidateQueries(["tax-zone"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update tax zone");
        },
    });

    return { updateTaxZoneMutate, isUpdating };
};
